import FavoriteButton from './favorite-button.jsx';

export {
  FavoriteButton
};



// WEBPACK FOOTER //
// ./components/partials/favorite-button/index.js